// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

var $ = require("./lib/qsa");

var selectDistrict = $.one("select.district");
var table = $.one(".table");
var tableTemplate = require("./lib/dot").compile(require("./_table.html"));

var salaries = window.salaryData.sort((a, b) => a.district < b.district ? -1 : 1);
var lookup = {};

salaries.forEach(function(row) {
  lookup[row.district] = row;
  if (row.district == "State Summary") return;
  var option = document.createElement("option");
  option.value = row.district;
  option.innerHTML = row.district;
  selectDistrict.appendChild(option);
});

var showDistrict = function(district) {
  var data = lookup[district];
  table.innerHTML = tableTemplate(data);
};

selectDistrict.addEventListener("change", function() {
  showDistrict(selectDistrict.value);
});

showDistrict("State Summary");